module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-table reset-password"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', [_c('h1', {
    staticClass: "headerone__default__large"
  }, [_vm._v("Enter your new password here:")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn__default save-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.loading) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "campaign-loader"
  }, [_c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('p', {
    staticClass: "invalid status-text"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('p', {
    staticClass: "valid status-text"
  }, [_vm._v("Password has been reset! You are being redirected in " + _vm._s(_vm.countdown) + " seconds.")]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-085283d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reset-password.vue
// module id = K2Ed
// module chunks = 1